import { Trans } from '@lingui/macro'
import Title from 'Root/App/Title'
import { useElementAuthorizationForGroups } from 'lib/use-element-authorization-for-groups'

import Loading from './Loading'
import AddGroup from './add-group'
import GroupAuthorizationRowItem from './group-auth-row-item'
import ShareSectionHeading from './share-section-heading'

const ShareToGroup = ({ elementId }) => {
  const { authorizationsGroups, groups, loading, error } =
    useElementAuthorizationForGroups(elementId)

  if (loading) {
    return <Loading />
  }

  if (error) {
    return <p>Error: {error.message}</p>
  }

  return (
    <div>
      <span id="share-to-group" className="flex flex-col gap-4">
        <ShareSectionHeading
          title={<Trans>Condividi a un gruppo</Trans>}
          subtitle={
            <Trans>
              Manderemo alle persone che fanno parte del gruppo un link magico e
              le istruzioni per accedere.
            </Trans>
          }
        />

        <AddGroup
          elementId={elementId}
          workspaceGroups={groups}
          workspaceId={null}
        />

        {authorizationsGroups.length > 0 && (
          <Title size="XS">
            <Trans>Condiviso con</Trans>:
            <hr className="mt-4 divide-gray-200" />
          </Title>
        )}

        <div role="list" className="flex flex-col divide-y divide-gray-200">
          {authorizationsGroups.map((authGroup) => (
            <GroupAuthorizationRowItem
              elementId={elementId}
              groupAuth={authGroup}
              key={authGroup.id}
            />
          ))}
        </div>
      </span>
    </div>
  )
}

export default ShareToGroup
